import BaseObject from '../../../../base/base_object';
import {FEATURE_CB_FUNC, KEY_NAME, SERIVCES_FUNC_LIST} from '../../native/native_const';
import Device from '../../../../utils/device/device';
import {ON_DEMAND} from "./on_demand_hybrid_consts";
import ServiceFactory from "../../../service_factory";
import {SYSTEM_EVENTS} from "../../../../events/events";
import Event from "../../../../utils/event";
import _ from "../../../../utils/underscore";
import DOM from "../../../../utils/dom";
import {BRANDS} from "../../../regulation/regulation_const";
import {NYX_COMPANY_NAME} from "../../../game/companies_names_consts";
import Store from "../../../../utils/store";


class OnDemandNyx extends BaseObject {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'OnDemandNyx';
    static NYX_TYPE = 'NYX';
    static NYX_ALL_GAME_IDS = 'nyxallgameids';

    _HybridService = null;
    _bUpdateHeaderHeight = false;
    _onDemandGameIsRunning = false;
    _isIframeSupport = false;
    _iframeEnable = false;
    _gameIndicatorInterval = null;
    _gameIndicatorCounter = 0;
    _gameIndicatorTimout = 0;
    _bIsFakegameIndicator = true;

    init(params) {

        super.init();
        if (_.isNullOrUndefined(params)) {
            return;
        }
        if (Device.os.isIOS) {
            params = params.ios;
            if (_.isNullOrUndefined(params)) {
                return;
            }

            if (!_.isNullOrUndefined(params.iframeEnable)) {
                this._iframeEnable = params.iframeEnable.enable;
            }

            if (!_.isNullOrUndefined(params.headerShift)) {
                this._bUpdateHeaderHeight = params.headerShift.enable;
            }

            this._gameIndicatorTimout = params.gameIndicatorTimout;

            if(this._gameIndicatorTimout < 0){
                this._gameIndicatorTimout = 0;
            }
        }
    }

    initFeatures(hybridSrv) {
        this._HybridService = hybridSrv;

        if (Device.hybrid.isEmbedded) {
            this._HybridService.setCbFunction(SERIVCES_FUNC_LIST.ON_DEMAND_NYX_SET_CB, FEATURE_CB_FUNC.HYBRID_ON_DEMAND_NYX_CALL);

            if(this._iframeEnable) {
                this._HybridService.checkNyxIframeSupport().then(data => {
                    data = _.safeJSONandDecode(data);
                    let dt = data[KEY_NAME.DATA];
                    this._isIframeSupport = 'true' === dt[KEY_NAME.VAL];
                });
            }
        }
        return this;
    }

    canHandle(companyName) {
        return companyName?.toUpperCase() === NYX_COMPANY_NAME;
    }

    _getNyxLocalHostUrl(url){

        let dataToSent = {// example of the parames
            [KEY_NAME.URL] : url,
            'domain' : 'ogs-gl-stage.nyxgib.eu',
            'operatorId' : '1387',
            'accountId' : '702740118',
            'gameId' : '70206',
            'sessionId' : 'MGMxNWQ0ZDMtOWU2Mi00NzhkLWIzZTYtODFmYTIzYjU2OWUy',
            'mode' : 'real',
            'language' : 'en_US',
            'currency' : 'USD',
            'device' : 'mobile',
            'jurisdiction' : '',
            'timeElapsedUK' : '0',
            'timeLimitUK' : '0',
            'timeElapsedMalta' : '0',
            'timeLimitMalta' : '0',
            'lobbyUrl' : 'http://www.888casino.com/lobbyUrl',
            'historyUrl' : ' http://www.888casino.com/historyurl',
            'selfAssessmentURL' : '',
            'depositLimitURL' : '',
            'selfExclusionURL' : '',
            'timeElapsed' : '0'
        };

         return this._HybridService.getNyxLocalHostUrl(dataToSent,'12345678').then(urlLocalHost => {

            //urlLocalHost example
            //http://localhost:17171/games/100/html5/gcmwrapper.html?clock=true&currency=USD&depositurl=&device=mobile&elapsedtime=0&envid=local&gameid=bonanza&gpid=100&jurisdiction=&lang=en_us&lobbyurl=http://www.888casino.com/lobbyUrl&mode=demo&nyxroot=ogs-gdm-stage.nyxgib.eu/nextgen/&ogsenv=gibraltarstage&ogsgameid=70206&operatorid=1387&realitycheck__timestamp=1675761459&secure=true&sessionid=Free:whigcl7ppb6lrvlu459j3tl1dsr&stage=1&type=nextgen

            window.location.href = urlLocalHost;
            //  this._HybridService.alert(urlLocalHost);
        });
    }

    updatOnDemandGameIsRunning(data) {

        this._onDemandGameIsRunning = true;

        if (this._bIsFakegameIndicator) {
            this.gameStartFakeIndicator(data);
        }
    }

    _storeifNotExistGameId(gameId) {

        let allGameIds = Store.get(OnDemandNyx.NYX_ALL_GAME_IDS, '');

        if(allGameIds.includes(gameId + ',')){
            return false;
        }

        allGameIds+= gameId + ',';

        Store.set(OnDemandNyx.NYX_ALL_GAME_IDS, allGameIds);

        return true;
    }

    gameStartFakeIndicator(data){

        if(!this._gameIndicatorTimout){//future hybrid version will send the real values
            return;
        }

        if(!this._storeifNotExistGameId(data.gameId)){
            return;
        }

        let self = this;
        this._gameIndicatorCounter = 0;

        const timeout = this._gameIndicatorTimout*10;

        self._gameIndicatorInterval = setInterval(function(){
            self._simulateGameLoadingIndicator();
            if(self._gameIndicatorCounter > 100){
                clearInterval(self._gameIndicatorInterval);
            }
        }, timeout);
    }

    stopgameIndicator(){
        clearInterval(this._gameIndicatorInterval);
        this._gameIndicatorInterval = 0;
        this._simulateGameLoadingIndicator();
    }

    _simulateGameLoadingIndicator(){
        Event.fire(SYSTEM_EVENTS.LOADING_INDICATOR_EMBEDDED_UPDATE_V2, {
            statusBar: this._gameIndicatorCounter.toString(),
            numberOfPackages: '1/1'
        });

        this._gameIndicatorCounter++;
    }

    navigate(companyName, url, gameType) {

        if (this.canHandle(companyName)) {



            Event.on(SYSTEM_EVENTS.SCREEN_RESIZE_CHANGED, this._onResize, this);
            Event.on(SYSTEM_EVENTS.SECOND_WEB_VIEW_CLOSE_ALL, this._onCloseAllWebViews, this);
            Event.on(SYSTEM_EVENTS.SECOND_WEB_VIEW_CLOSE_NYX, this._onCloseNyx, this);

            Event.once(SYSTEM_EVENTS.GAME_SEQUENCE_FINISH, (status) => {
                this._onGameSequenceFinish(status)
            }, this);

            this._HybridService.navigateForOnDemandNyx(url, gameType);
            this._updateHeaderheight();
            this._onDemandGameIsRunning = true;
            return true;
        }

        return false;
    }

    isIframeSupported(){
        return this._isIframeSupport;
    }

    _getHeaderClassName() {
        const brandID = this._HybridService.serviceFactory.skinService().getBrandID();

        if(this._HybridService.serviceFactory.skinService().isCOMBrand()
            || brandID === BRANDS.SPAIN
            || brandID === BRANDS.CANADA
            || brandID === BRANDS.MICHIGAN) {
            return '.orbit-game-header-in-app-header';
        }

        return '.cy-header-regulation-data';
    }

    _waitForTheHeaderElementToBeInDOM() {
        let headerClassName = this._getHeaderClassName();
        return new Promise(resolve => {
            const startTime = Date.now();
            const intervalRef = setInterval(() => {
                const elementRef = DOM.querySelector(headerClassName);
                if(elementRef && elementRef.offsetHeight > 0) {
                    clearInterval(intervalRef);
                    resolve(elementRef.offsetHeight);
                }
                else if(Date.now() - startTime > 3 * 1000) {
                    clearInterval(intervalRef);
                    resolve(0);
                }
            }, 10);
        });
    }

    async _getHeaderHeight() {

        const headerShiftDisable =  !this._bUpdateHeaderHeight;
        const netPositionDisable =  !this._HybridService.serviceFactory.regulationService().getRegulation().showNetPosition();

        if(headerShiftDisable && netPositionDisable){
            return 0;
        }

        try{
            return await this._waitForTheHeaderElementToBeInDOM();
        }
        catch (e){
            this.logger.error('Error topHeaderElement height can be calculated, error msg: ', e);
            return 0
        }
    }


    _getBrandenable(){
        const isEnable = this._HybridService.serviceFactory.regulationService().getRegulation().hybridNyxClosedButtonEnabled();
        return isEnable ? 'true' : 'false'
    }

    _getCloseButPosition(){

        let xp = 0;
        let yp = 0;
        let xl = 0;
        let yl = 0;

        if(Device.hybrid.isEmbedded && !Device.hybrid.inPoker && !Device.hybrid.inSport) {
            if(Device.isIphoneX()) {
                xp = -10;
                yp = 10;
                xl = -10;
                yl = 20;
            }
        }

        let enable = this._getBrandenable();

        let dt = {
            'enable': enable,
            'xp': xp,
            'yp': yp,
            'xl': xl,
            'yl': yl
        };

        return dt;
    }

    async _updateHeaderheight(){

        let headerHeight = await this._getHeaderHeight();

        let dt = this._getCloseButPosition();

        this._HybridService.changeHeaderHeightOnDemandNyx(headerHeight, dt);
    }

    _onResize() {
        this._updateHeaderheight();
    }

    _onGameSequenceFinish(status){
        if(status) {
            this._updateHeaderheight();
        }
    }

    onHybridDirectCall(data) {

        let fn = this.getFuncName(data);

        if ('function' === typeof this[fn]) {
            this[fn](data);
        }
    }

    getFuncName(data) {
        let fn = data[ON_DEMAND.CB_FN];

        return undefined !== fn ? fn : '';
    }

    onLoadErrorIframe(data){
       // console.log('AAAAAA: onLoadErrorIframe');
    }

    onNyxEvent(data) {

        let reason = this._getReason(data);

        let isClose = ServiceFactory.create().gameReasonService().handleReason(reason);
        if (isClose) {
            this.onclose();
        }
    }

    onNyxPostMsg(data){

        let msg = {
            data: {}
        };

        try {
            let val = data[KEY_NAME.DATA];
            msg.data.gcmevent = decodeURIComponent(val);
        }
        catch (e) {
            msg.data.gcmevent = '';
        }

        Event.fire(SYSTEM_EVENTS.HYBRID_POST_MESSAGE_ARRIVE, msg);
    }

    _closeAndInit(){
        this._onDemandGameIsRunning = false;
        Event.off(SYSTEM_EVENTS.SCREEN_RESIZE_CHANGED, this._onResize, this);
        Event.off(SYSTEM_EVENTS.SECOND_WEB_VIEW_CLOSE_ALL, this._onCloseAllWebViews, this);
        Event.off(SYSTEM_EVENTS.SECOND_WEB_VIEW_CLOSE_NYX, this._onCloseNyx, this);


        Event.fire(SYSTEM_EVENTS.CLOSE_GAME);
    }

    onclose() {
        this._HybridService.closeNyxODRGame();
        this._closeAndInit();
    }

    _onCloseNyx() {

        this._HybridService.closeNyxODRGame();

        if(this.isOnDemandStandAloneGameRunning()) {
            this._closeAndInit();
        }
    }

    _onCloseAllWebViews(){
        if(this.isOnDemandStandAloneGameRunning()) {
            this._closeAndInit();
        }
    }

    isOnDemandStandAloneGameRunning() {
        return this._onDemandGameIsRunning;
    }

    _getReason(data) {

        let url;

        try {
            let val = data[KEY_NAME.DATA];
            url = decodeURIComponent(val);
        }
        catch (e) {
            url = null;
        }

        if (null === url) {
            return null;
        }

        let extractFirstPart = url.split('?')[1];

        if ('undefined' === typeof extractFirstPart) {
            return null;
        }

        let allowedPattern = /^reason=([0-9]{1,2})/,
            matchedURL = extractFirstPart.match(allowedPattern),
            reasonID = Array.isArray(matchedURL) ? Number(matchedURL[1]) : false;

        return reasonID;
    }

}
export default OnDemandNyx;
